import EsignCNModule from './esignCNContainer';
import EsignCNMobileModule from './esignCNContainer.mobile'
import {isMobile} from 'Utils/device';
import './esignCN.scss'

const EsignCNModuleFn = isMobile ? EsignCNMobileModule : EsignCNModule;

export default EsignCNModuleFn;
